import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationUtil, VALIDATION_MESSAGES } from 'src/app/utils/validation.util';


@Component({
    selector: 'Comment-dialog',
    templateUrl: './comment-dialog.component.html',
    styleUrls: ['./comment-dialog.component.scss']
})

export class CommentDialogue implements OnInit, OnDestroy {

    commentForm;
    validationMsg = VALIDATION_MESSAGES;
    constructor(
        private matDialogRef: MatDialogRef<CommentDialogue>,
        private fb: FormBuilder,
    ) {
        this.commentForm = this.fb.group({
            comment: ['', Validators.compose([
                Validators.required,
                ValidationUtil.cannotBeBlank,
              ])],
        });
    }

    ngOnInit() {

    }

    onCancelClick() {
        this.matDialogRef.close();
    }

    doSubmit() {
        if(this.commentForm.valid){
            this.matDialogRef.close(this.commentForm.value.comment)
        }        
    }

    ngOnDestroy() {
    }

}
